/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/* eslint-disable */

window.PXUTheme.jsAjaxCart = {
  init: function ($section) {

    // Add settings from schema to current object
    window.PXUTheme.jsAjaxCart = $.extend(this, window.PXUTheme.getSectionData($section));

    if (isScreenSizeLarge() || this.cart_action == 'drawer') {
      this.initializeAjaxCart();
    } else {
      this.initializeAjaxCartOnMobile();
    }

    if (this.cart_action == 'drawer') {

      this.ajaxCartDrawer = $('[data-ajax-cart-drawer]');

      $(document).on('click', '[data-ajax-cart-trigger]', function (e) {
        e.preventDefault();
        window.PXUTheme.jsAjaxCart.showDrawer();

        return false;
      });

      // The trigger is an <a href="/cart">, so Enter activates it natively and
      // the click handler above opens the drawer. Space does not activate a
      // link -- it scrolls the page -- so it has to be handled explicitly for
      // both keys to do the same thing. Enter is deliberately left out here so
      // it does not fire alongside the native activation.
      $(document).on('keydown', '[data-ajax-cart-trigger] a', function (e) {
        if (e.key !== ' ' && e.key !== 'Spacebar') return;

        e.preventDefault();
        window.PXUTheme.jsAjaxCart.showDrawer();
      });

      // Escape closes it. Expected of anything with role="dialog", and it
      // matters more now focus is moved inside: without it the only way out is
      // to Tab around until the close button comes up.
      $(document).on('keydown', function (e) {
        if (e.key !== 'Escape' && e.key !== 'Esc') return;
        if (!window.PXUTheme.jsAjaxCart.ajaxCartDrawer) return;
        if (!window.PXUTheme.jsAjaxCart.ajaxCartDrawer.hasClass('is-visible')) return;

        window.PXUTheme.jsAjaxCart.hideDrawer();
      });

      // Keep Tab inside the drawer while it is open: from the last control (the
      // "go to cart" link) it wraps back to the close button, and Shift+Tab off
      // the close button wraps to the end. The drawer declares
      // aria-modal="true", which tells assistive tech the rest of the page is
      // inert -- without this, Tab walked straight out into the page behind and
      // that claim was untrue.
      $(document).on('keydown', function (e) {
        if (e.key !== 'Tab') return;

        const $drawer = window.PXUTheme.jsAjaxCart.ajaxCartDrawer;
        if (!$drawer || !$drawer.hasClass('is-visible')) return;

        const focusable = window.PXUTheme.jsAjaxCart.getFocusable($drawer[0]);
        if (!focusable.length) return;

        const first = focusable[0];
        const last = focusable[focusable.length - 1];

        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      });

    } else if (this.cart_action == 'mini_cart') {
      this.showMiniCartOnHover();
    } else {
      $(document).on('click', '[data-ajax-cart-trigger]', function (e) {
        window.location.href = (window.PXUTheme && window.PXUTheme.routes && window.PXUTheme.routes.cart_url) || '/cart';
      });
    }

    $(document).on('click', '.ajax-submit', function (e) {
      e.preventDefault();
      const $addToCartForm = $(this).closest('form');
      window.PXUTheme.jsAjaxCart.addToCart($addToCartForm);

      return false;
    });

    $(document).on('click', '[data-ajax-cart-delete]', function (e) {
      e.preventDefault();
      const lineID = $(this).parents('[data-line-item]').data('line-item');
      window.PXUTheme.jsAjaxCart.removeFromCart(lineID);

      if (window.PXUTheme.jsCart) {
        window.PXUTheme.jsCart.removeFromCart(lineID);
      }

      return false;
    });

    $(document).on('click', '[data-ajax-cart-close]', function (e) {
      e.preventDefault();
      window.PXUTheme.jsAjaxCart.hideDrawer();
      window.PXUTheme.jsAjaxCart.hideMiniCart();

      return false;
    });

  },
  showMiniCartOnHover: function () {
    const $el = $('[data-ajax-cart-trigger]');

    $el.hover(function() {
      if(window.PXUTheme.theme_settings.header_layout == 'centered' && $('.header-sticky-wrapper').hasClass('is-sticky')) {
        $('.header-sticky-wrapper [data-ajax-cart-trigger]').addClass('show-mini-cart');
      } else {
        $el.addClass('show-mini-cart');
      }
    }, function() {
      $el.removeClass('show-mini-cart');
    });
  },
  hideMiniCart: function () {
    if (this.cart_action != 'mini_cart') return false;
    const $el = $('[data-ajax-cart-close]').parents('[data-ajax-cart-trigger]');
    $el.removeClass('show-mini-cart');
  },
  toggleMiniCart: function() {
    const $el = $('.mobile-header [data-ajax-cart-trigger]');

    // Removes url to the cart page so user is not redirected
    $el.attr('href', '#');

    $el.off('touchstart').on('touchstart', function (e) {
      // If user clicks inside the element, do nothing
      if (e.target.closest('[data-ajax-cart-mini_cart]')) {
        return;
      }

      // Loads content into ajaxCart container for mobile header
      window.PXUTheme.jsAjaxCart.initializeAjaxCartOnMobile();

      // If user clicks outside the element, toggle the mini cart
      $el.toggleClass('show-mini-cart');
    });
  },
  getFocusable: function (container) {
    if (!container) return [];

    const selector = 'a[href], button:not([disabled]), input:not([disabled]),' +
      ' select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    // Skip anything not rendered -- the empty-cart message and the item form
    // swap places with is-hidden, and a hidden control must not take a turn in
    // the cycle. #PopupCartID is tabindex="-1" so it is excluded by the
    // selector: it is a programmatic focus target, not a tab stop.
    return Array.prototype.filter.call(container.querySelectorAll(selector), function (el) {
      return el.offsetWidth > 0 || el.offsetHeight > 0 || el.getClientRects().length > 0;
    });
  },
  showDrawer: function (announcement) {
    if (this.cart_action != 'drawer') return false;

    // What the announcer reads when focus lands on it. Callers that have
    // something specific to say (add to cart) pass it in; every other open
    // falls back to the default so a stale "X was added" is never re-announced.
    const $announcer = $('#PopupCartID');
    if ($announcer.length) {
      $announcer.attr('aria-label', announcement || $announcer.attr('data-default-label') || '');
    }

    // Remember what opened the drawer so focus can be handed back on close;
    // otherwise focus falls to the top of the document and the customer loses
    // their place in the page.
    this.drawerReturnFocus = document.activeElement;

    this.ajaxCartDrawer.addClass('is-visible');
    $('.ajax-cart__overlay').addClass('is-visible');

    this.focusAnnouncer();
  },
  // Moving focus inside is what makes the drawer announce itself. #PopupCartID
  // is first so its label is what gets read; the close button and then the
  // panel itself are fallbacks for markup where it is absent. Deferred a frame
  // so the element is painted before it is focused.
  //
  // Split out of showDrawer because an add to cart replaces the cart list a
  // moment after the drawer opens, and focus has to be re-asserted once that
  // finishes.
  focusAnnouncer: function () {
    const drawer = this.ajaxCartDrawer && this.ajaxCartDrawer[0];
    if (!drawer) return;

    const target = drawer.querySelector('#PopupCartID') ||
      drawer.querySelector('[data-ajax-cart-close]') ||
      drawer;

    window.requestAnimationFrame(function () {
      target.focus();
    });
  },
  hideDrawer: function () {
    if (this.cart_action != 'drawer') return false;
    this.ajaxCartDrawer.removeClass('is-visible');
    $('.ajax-cart__overlay').removeClass('is-visible');

    // Put focus back where it came from, but only if it is still inside the
    // drawer -- if the customer has already clicked elsewhere, leave them be.
    const returnTo = this.drawerReturnFocus;
    this.drawerReturnFocus = null;

    const drawer = this.ajaxCartDrawer[0];
    const focusLeftDrawer = drawer && !drawer.contains(document.activeElement);
    if (focusLeftDrawer) return;

    if (returnTo && typeof returnTo.focus === 'function' && document.contains(returnTo)) {
      returnTo.focus();
    }
  },
  removeFromCart: function (lineID, callback) {
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=0&line=' + lineID,
      dataType: 'json',
      success: function (cart) {
        window.PXUTheme.jsAjaxCart.updateView();
      },
      error: function (XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;

      }
    });
  },
  initializeAjaxCart: function () {

    window.PXUTheme.asyncView.load(
      window.PXUTheme.routes.cart_url, // template name
      'ajax', // view name (suffix)
    )
      .done(({ html, options }) => {

        $('[data-ajax-cart-content]').html(html.content);

        // Converting the currencies
        if (window.PXUTheme.currencyConverter) {
          window.PXUTheme.currencyConverter.convertCurrencies();
        }

      })
      .fail(() => {
        // some error handling
      });
  },
  initializeAjaxCartOnMobile: function () {

    this.toggleMiniCart();

    window.PXUTheme.asyncView.load(
      window.PXUTheme.routes.cart_url, // template name
      'ajax', // view name (suffix)
    )
      .done(({ html, options }) => {

        $('.mobile-header [data-ajax-cart-content]').html(html.content);

      })
      .fail(() => {
        // some error handling
      });
  },
  addToCart: function ($addToCartForm) {
    const $addToCartBtn = $addToCartForm.find('.button--add-to-cart');
    this.recipientForm = $addToCartForm[0].querySelector('[data-recipient-form]');

    if (this.recipientForm) {
      this.recipientForm.classList.remove('recipient-form--has-errors');
    }

    $addToCartForm.removeClass('shopify-product-form--unselected-error');

    if ($addToCartBtn[0].hasAttribute('data-options-unselected')) {
      const cartWarning = `<p class="cart-warning__message animated bounceIn">${window.PXUTheme.translation.select_variant}</p>`;

      $('.warning').remove();

      $addToCartForm
        .addClass('shopify-product-form--unselected-error')
        .find('.cart-warning')
        .html(cartWarning);

      $addToCartBtn
        .removeAttr('disabled')
        .removeClass('disabled');

      $addToCartBtn.find('.icon')
        .removeClass('zoomOut')
        .addClass('zoomIn');

      $addToCartBtn
        .find('span:not(.icon)')
        .text($addToCartBtn.data('label'))
        .removeClass('zoomOut')
        .addClass('zoomIn');
    } else {
      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: $addToCartForm.serialize(),
        beforeSend: function () {
          $addToCartBtn
            .attr('disabled', 'disabled')
            .addClass('disabled');

          $addToCartBtn.find('span')
            .removeClass("fadeInDown")
            .addClass('animated zoomOut');
        },
        success: function (product) {
          let $el = $('[data-ajax-cart-trigger]');

          $addToCartBtn
            .find('.checkmark')
            .addClass('checkmark-active');

          function addedToCart() {

            if (!isScreenSizeLarge()) {
              $el = $('.mobile-header [data-ajax-cart-trigger]');
              window.PXUTheme.scrollToTop($el);
            } else {
              $el = $('[data-ajax-cart-trigger]');
            }

            $el.addClass('show-mini-cart');

            $addToCartBtn.find('span')
              .removeClass('fadeInDown');
          }

          window.setTimeout(function () {
            $addToCartBtn
              .removeAttr('disabled')
              .removeClass('disabled');

            $addToCartBtn.find('.checkmark')
              .removeClass('checkmark-active');

            $addToCartBtn.find('.text, .icon')
              .removeClass('zoomOut')
              .addClass('fadeInDown');

            $addToCartBtn.on('webkitAnimationEnd oanimationend msAnimationEnd animationend', addedToCart);

          }, 1000);

          // Say what was just added. showDrawer puts this on #PopupCartID's
          // aria-label and then moves focus to it, so it is read out as the
          // drawer opens rather than needing a separate live region.
          // /cart/add.js returns the price in cents.
          const cents = product.final_price != null ? product.final_price : product.price;
          const price = (cents / 100).toFixed(2);

          // Gift card title is "Gift Card - $10.00"; screen readers read "- $10.00" as "minus ten dollars"
          const itemTitle = product.gift_card && product.variant_title
            ? product.product_title + ', ' + product.variant_title
            : product.title;

          const announcement = 'Your Shopping Cart is open on a popup. ' +
            itemTitle + ', quantity ' + product.quantity +
            ', price $' + price + ' product has added to cart.';

          window.PXUTheme.jsAjaxCart.showDrawer(announcement);

          // The add-to-cart button is disabled while the request is in flight,
          // which drops focus to <body>, and updateView then replaces the cart
          // list underneath. Put focus back on the announcer once that settles
          // -- but only if it landed on <body>, so a customer who has already
          // tabbed to the close button is not yanked back.
          function focusAnnouncerIfLoose() {
            const active = document.activeElement;
            if (active && active !== document.body) return;

            window.PXUTheme.jsAjaxCart.focusAnnouncer();
          }

          const updating = window.PXUTheme.jsAjaxCart.updateView();
          if (updating && typeof updating.always === 'function') {
            updating.always(focusAnnouncerIfLoose);
          } else {
            focusAnnouncerIfLoose();
          }

          if (window.PXUTheme.jsCart) {
            $.ajax({
              dataType: "json",
              async: false,
              cache: false,
              dataType: 'html',
              url: "/cart",
              success: function (html) {
                const cartForm = $(html).find('.cart__form');
                $('.cart__form').replaceWith(cartForm);

              }
            });
          }

        },
        error: XMLHttpRequest => {
          const response = eval('(' + XMLHttpRequest.responseText + ')');

          $('.warning').remove();

          let cartWarning;

          if (response.errors && response.errors.email) {
            this.recipientForm.classList.add('recipient-form--has-errors');
          } else {
            cartWarning = `<p class="cart-warning__message animated bounceIn">${response.description.replace('All 1 ', 'All ')}</p>`;
          }

          $addToCartForm
            .find('.cart-warning')
            .html(cartWarning);

          $addToCartBtn
            .removeAttr('disabled')
            .removeClass('disabled');

          $addToCartBtn.find('.icon')
            .removeClass('zoomOut')
            .addClass('zoomIn');

          $addToCartBtn
            .find('span:not(.icon)')
            .text($addToCartBtn.data('label'))
            .removeClass('zoomOut')
            .addClass('zoomIn');
        }
      });
    }
  },
  updateView: function () {

    // Returned so callers can wait for the swap -- addToCart restores focus to
    // the announcer once the new cart list is in the DOM.
    return window.PXUTheme.asyncView.load(
      window.PXUTheme.routes.cart_url, // template name
      'ajax', // view name (suffix)
    )
    .done(({ html, options }) => {

      if (options.item_count > 0) {
        const itemList = $(html.content).find('.ajax-cart__list');
        const cartDetails = $(html.content).find('.ajax-cart__details-wrapper');

        $('.ajax-cart__list').replaceWith(itemList);
        $('.ajax-cart__details-wrapper').replaceWith(cartDetails);
        $('.ajax-cart__empty-cart-message').addClass('is-hidden');
        $('.ajax-cart__form').removeClass('is-hidden');
        $('[data-ajax-cart-trigger]').addClass('has-cart-count');
        $('[data-bind="itemCount"]').text(options.item_count);

      } else {
        $('.ajax-cart__empty-cart-message').removeClass('is-hidden');
        $('.ajax-cart__form').addClass('is-hidden');
        $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
        $('[data-bind="itemCount"]').text('0');
      }

      if (window.PXUTheme.currencyConverter) {
        window.PXUTheme.currencyConverter.convertCurrencies();
      }
    })
    .fail(() => {
      // some error handling
    });
  },
  unload: function ($section) {

    // Clear event listeners in theme editor
    $('.ajax-submit').off();
    $('[data-ajax-cart-delete]').off();
  }
}

/******/ })()
;